var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"catalog-search-panel",style:({ top: _vm.headerBottom + 'px' }),attrs:{"aria-label":_vm.$t('search.language_0')}},[(_vm.visible)?_c('Search',{ref:"search",attrs:{"embedded":""},on:{"closeSearch":_vm.close}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }